export default __webpack_public_path__ + "static/media/template7.797bf149.png";